import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SouthIcon = _resolveComponent("SouthIcon")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_NorthIcon = _resolveComponent("NorthIcon")!
  const _component_EditIcon = _resolveComponent("EditIcon")!
  const _component_DeleteIcon = _resolveComponent("DeleteIcon")!
  const _component_BaseTable = _resolveComponent("BaseTable")!
  const _component_Page = _resolveComponent("Page")!

  return (_openBlock(), _createBlock(_component_Page, {
    title: _ctx.pageTitle,
    "header-buttons": [
      {
        text: 'Создать поле товарного типа',
        href: _ctx.getFieldCreateFormUrl({
          productTypeId: _ctx.productTypeId,
          fieldId: 'create',
        }),
      },
    ]
  }, {
    content: _withCtx(() => [
      _createVNode(_component_BaseTable, {
        "column-defs": _ctx.columnDefs,
        "row-data": _ctx.rowData,
        loading: _ctx.isRowDataLoading,
        "error-message": _ctx.errorMessage,
        enumerable: true
      }, {
        "cell(type)": _withCtx(({ row }) => [
          _createTextVNode(_toDisplayString(_ctx.typeTranslation(row.type)), 1)
        ]),
        "cell(actions)": _withCtx(({ row, rowIndex }) => [
          _createElementVNode("div", null, [
            _createVNode(_component_BaseButton, {
              variant: "icon",
              disabled: _ctx.isBusy(row.id) || rowIndex === _ctx.rowData.length - 1,
              onClick: ($event: any) => (_ctx.handleFieldMove(row.id, 'down'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_SouthIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_BaseButton, {
              variant: "icon",
              disabled: _ctx.isBusy(row.id) || rowIndex === 0,
              onClick: ($event: any) => (_ctx.handleFieldMove(row.id, 'up'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_NorthIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]),
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Edit",
              disabled: _ctx.isBusy(row.id),
              href: 
                _ctx.getFieldEditFormUrl({
                  fieldId: row.id,
                })
              
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EditIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "href"]),
            _createVNode(_component_BaseButton, {
              variant: "icon",
              title: "Delete",
              disabled: _ctx.isBusy(row.id),
              onClick: ($event: any) => (_ctx.handleFieldDelete(row.id))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DeleteIcon)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["column-defs", "row-data", "loading", "error-message"])
    ]),
    _: 1
  }, 8, ["title", "header-buttons"]))
}